import { render } from "./xtx-more.vue?vue&type=template&id=d6f2c104&scoped=true"
import script from "./xtx-more.vue?vue&type=script&lang=js"
export * from "./xtx-more.vue?vue&type=script&lang=js"

import "./xtx-more.vue?vue&type=style&index=0&id=d6f2c104&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6f2c104"]])

export default __exports__